import React from 'react';
import { Col} from 'reactstrap';
import Readstories from './readStories';
import Masonry from './imageGallery';


const giveassuredImages = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


		<h2 className="text-heading-giveAssured" >Check out photos from our visits </h2>

		<Masonry />

		<p style={{ paddingTop: '2rem' }}><Readstories /></p>


	</Col>


);

export default giveassuredImages;
